const filter = [
  {text: 'Код активации', value: 'key', op: 'contains'},
  {text: 'Профиль', value: 'subject.name', op: 'contains', extra: [{field: 'subjectType', value: 'profile', op: 'eq'}] },
  {text: 'Пакет приложения', value: 'subject.package', op: 'contains', extra: [{field: 'subjectType', value: 'package', op: 'eq'}] },
  
];

const sort = [
  {text: 'По дате создания', value: 'createdAt', type: 'asc'},
  {text: 'По дате создания', value: 'createdAt', type: 'desc', default: true}
];

export { filter, sort };